import { render, staticRenderFns } from "./StudentIdentifierHeaderView.vue?vue&type=template&id=a37f8eb4&scoped=true&"
import script from "./StudentIdentifierHeaderView.vue?vue&type=script&lang=js&"
export * from "./StudentIdentifierHeaderView.vue?vue&type=script&lang=js&"
import style0 from "./StudentIdentifierHeaderView.vue?vue&type=style&index=0&id=a37f8eb4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37f8eb4",
  null
  
)

export default component.exports